<app-card-with-header>
  <div header>
    {{ titleKey | translate }}
  </div>
  <div class="pb-[1.25rem]">
    @if (!areTreatmentsLoaded) {
      <p-skeleton width="33%" height="30px" class="ml-[1.25rem] mb-[0.625rem]"></p-skeleton>
      <p-skeleton width="33%" height="30px" class="ml-[1.25rem] mb-[0.625rem]"></p-skeleton>
      <p-skeleton width="33%" height="30px" class="ml-[1.25rem] mb-[0.625rem]"></p-skeleton>
    } @else {
      @if (treatments.length === 0) {
        <p class="pl-[1.25rem]">{{ (emptyMessageKey | translate) }}</p>
      } @else {
        <div class="grid grid-cols-3 gap-[1.25rem] w-[50%] items-center">
          @for (treatment of treatments; track treatment.id) {
            <div>
              {{ getDate(treatment.appointmentDate) }} {{ getTime(treatment.appointmentDate) }}
            </div>
            <div>
              <p-button [routerLink]="'../customer-detail/'+treatment.ownerId">
                <span class="material-icons !text-[1rem]">person</span>
              </p-button>&nbsp;
              <p-button [routerLink]="'../pet-detail/'+treatment.patientId">
                <span class="material-icons !text-[1rem]">pets</span>
              </p-button>&nbsp;
              <p-button [routerLink]="'../treatment-detail/'+treatment.id">
                <span class="material-icons !text-[1rem]">event</span>
              </p-button>
            </div>
            <div>
              {{ treatment.ownerFirstName + " " + treatment.ownerLastName + " - " + treatment.patientName }}
            </div>
          }
        </div>
      }
    }
  </div>
</app-card-with-header>
